/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import Textfield from "@react/react-spectrum/Textfield";
import { isMac, isWindows } from "dc-preview-utils/src/Utils/DeviceUtils";
import * as codes from "dc-preview-utils/src/Constants/key-codes";

const Dialog = require("@react/react-spectrum/Dialog").default;

class InputDialog extends Component {
  constructor() {
    super();
    this.inputValue = "";
    this.onChange = this.onChange.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onChange(value) {
    this.inputValue = value;
    this.props.onChange();
  }

  onConfirm() {
    if (this.props.onSubmit) {
      this.props.onSubmit(this.inputValue);
    }
  }

  onCancel() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  onKeyDown(ev) {
    if (ev.keyCode === codes.ENTER && this.props.onSubmit) {
      this.props.onSubmit(this.inputValue);
    }
  }

  render() {
    const formatMessage = this.props.intl.formatMessage;
    const localeStrings = this.props.localeStrings;
    const secondaryText = localeStrings.secondaryText ? formatMessage({ id: localeStrings.secondaryText }) : "";

    const textFieldStyle = {
      width: "100%"
    };

    return (
      <Dialog
        onConfirm={this.onConfirm}
        onCancel={this.onCancel}
        title={localeStrings.title ? formatMessage({ id: localeStrings.title }) : ""}
        confirmLabel={formatMessage({ id: localeStrings.confirmLabel })}
        cancelLabel={
          this.props.dontShowCancelButtonformatMessage ? null : formatMessage({ id: localeStrings.cancelLabel })
        }
        id={this.props.id ? this.props.id : "dialog"}
      >
        <p>
          {localeStrings.primaryText.str
            ? formatMessage({ id: localeStrings.primaryText.str }, localeStrings.primaryText.values)
            : ""}
        </p>
        <Textfield
          aria-invalid="false"
          onKeyDown={this.onKeyDown}
          placeholder={localeStrings.placeholder ? formatMessage({ id: localeStrings.placeholder }) : ""}
          type={this.props.dialogType || "text"}
          autoFocus
          style={textFieldStyle}
          validationState={this.props.hasError ? "invalid" : ""}
          onChange={this.onChange}
        />
        {/* for accessibility */}
        {this.props.hasError && isMac() ? (
          <p aria-live="assertive" style={{ color: "red" }}>
            {secondaryText}
          </p>
        ) : null}
        {isWindows() ? (
          <p aria-live="assertive">{this.props.hasError ? <p style={{ color: "red" }}>{secondaryText}</p> : null}</p>
        ) : null}
      </Dialog>
    );
  }
}

export { InputDialog };
